import { format, isValid, parse } from 'date-fns';
import { DATE_INPUT_FORMAT, TIME_INPUT_FORMAT } from '../../../constants';

interface ParseExactArgs {
  text: string;
  formatString: string;
  referenceDate: Date;
}

const parseExact = ({ text, formatString, referenceDate }: ParseExactArgs) => {
  const parsed = parse(text, formatString, referenceDate);

  if (!isValid(parsed) || format(parsed, formatString) !== text) {
    return null;
  }

  return parsed;
};

interface ParseTimeInputArgs {
  text: string;
  referenceDate: Date;
}

export const parseDateInput = (text: string) =>
  parseExact({ text, formatString: DATE_INPUT_FORMAT, referenceDate: new Date() });

export const parseTimeInput = ({ text, referenceDate }: ParseTimeInputArgs) =>
  parseExact({ text, formatString: TIME_INPUT_FORMAT, referenceDate });
